import { Grid } from '@mui/material'
import React from 'react'

import SubCard from 'ui-component/cards/SubCard'
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AgentTable from './Components/Mapping/Mapping_tm_mds/MDSTable';
import InputLabel from '@mui/material/InputLabel';
import { useState } from 'react';
import { useEffect } from 'react';
// import { Getstates } from 'API/DsOnboarding/api';
import { fetchStates, fetchSubDistrict } from 'API/AgentOnboarding/api';
import {   getMds } from 'API/Mapping/api';




const Mapping_tm_mds = () => {
    // const [status, setStatus] = React.useState(false);
    const[State,setState]=useState(null)
    const[SubDistrict,setSubDistrict]=useState(null)
    const[Data,setData]=useState({})
    const[Selected,setSelected]=useState(false)
    const [MappingType,setMappingtype]=useState(null)
    const [AgentList,setAgentList]=useState(null)
    const[Status,setStatus]=useState('unmapped')

    const handleChange = (name,value) => {
        setData({ ...Data, [name]: value });
    };

    const handleStatusChange=(name,value) => {
        setStatus(value)
    }

    useEffect(()=>{
        getMds(Status,"TM",setAgentList)
    },[Status])

    const handleMapping=(value)=>{
        setMappingtype(value)
    }
    
    useEffect(()=>{
        fetchStates(setState)
    },[])

    console.log(State);
    console.log(SubDistrict,setSubDistrict);

    useEffect(()=>{
        if(Data.district){
            fetchSubDistrict(Data.district, setSubDistrict);
        }
    },[Data.district])


    return (
        <SubCard title='Mapping' sx={{height:'80vh',overflowY:'scroll'}}>

            <Grid container justifyContent='space-between' gap={1} sx={{display:Selected?'none':'flex'}}>
                <Grid item xl={2} md={6} lg={4} sm={12} xs={12}>
                    <Box>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                            <Select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Status"
                                value={Status}
                                onChange={(e)=>handleStatusChange("status",e.target.value)}
                            >
                                <MenuItem value={'unmapped'}>Unmapped Agents</MenuItem>
                                <MenuItem value={'mapped'}>Mapped agents</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item xl={2} md={6} lg={4} sm={12} xs={12}>
                    <Box>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">State</InputLabel>
                            <Select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                label="State"
                                value={Data.state?Data.state:''}
                                onChange={(e)=>handleChange('state',e.target.value)}
                            >
                                {
                                   State&& Object.entries(State).map(([key])=>(

                                        <MenuItem key={key} value={key}>{key}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item xl={2} md={6} lg={4} sm={12} xs={12}>
                    <Box>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">District</InputLabel>
                            <Select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                label="District"
                                value={Data.district?Data.district:''}
                                onChange={(e)=>handleChange('district',e.target.value)}
                            >
                                {
                                    Data.state&&State[Data.state].map((item,index)=>(

                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item xl={2} md={6} lg={4} sm={12} xs={12}>
                    <Box>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Sub District</InputLabel>
                            <Select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Sub District"
                                value={Data.subdistrict?Data.subdistrict:''}
                                onChange={(e)=>handleChange('subdistrict',e.target.value)}
                            >
                                {
                                    SubDistrict&&
                                    Object.entries(SubDistrict).map(([key])=>(

                                        <MenuItem key={key} value={key}>{key}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item xl={2} md={6} lg={4} sm={12} xs={12}>
                    <Box>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Mapping Type</InputLabel>
                            <Select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Mapping Type"
                                value={MappingType}
                                onChange={(e)=>handleMapping(e.target.value)}
                            >
                                <MenuItem value={'Unmapped Agents'}>Unmapped</MenuItem>
                                <MenuItem value={'Mapped agents'}>Mapped</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mt={5}>
                <Grid item xl={12} sx={{overflowX:'scroll'}}>
                    <AgentTable data={AgentList} status={Status} setSelected={setSelected}/>
                </Grid>
            </Grid>

        </SubCard>
    )

}


export default Mapping_tm_mds